import React, { createContext, useContext, useState, useEffect } from 'react';
import { settingsApi } from '../services/api/settings.api';

const SettingsContext = createContext();

export const useSettings = () => {
    return useContext(SettingsContext);
};

export const SettingsProvider = ({ children }) => {
    const [settings, setSettings] = useState({
        siteTitle: '',
        siteDescription: '',
        keywords: '',
        socialLinks: {
            whatsapp: { enabled: false, url: '', name: 'واتساب' },
            twitter: { enabled: false, url: '', name: 'تويتر' },
            youtube: { enabled: false, url: '', name: 'يوتيوب' },
            telegram: { enabled: false, url: '', name: 'تليجرام' }
        }
    });

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadSettings();
    }, []);

    const loadSettings = async () => {
        try {
            // التحقق أولاً من البيانات المخزنة في sessionStorage
            const cachedSettings = sessionStorage.getItem('seo_settings');
            
            if (cachedSettings) {
                try {
                    const parsedSettings = JSON.parse(cachedSettings);
                    const cacheTime = parsedSettings._cacheTime || 0;
                    
                    // استخدام القيم المخزنة إذا كانت حديثة (أقل من 5 دقائق)
                    if (Date.now() - cacheTime < 5 * 60 * 1000) {
                        // استخدام إعدادات SEO من التخزين المؤقت
                        delete parsedSettings._cacheTime; // إزالة معلومات التخزين المؤقت
                        setSettings(parsedSettings);
                        setLoading(false);
                        return;
                    }
                } catch (e) {
                    // تم التعامل مع خطأ قراءة إعدادات SEO المخزنة
                    // في حالة الخطأ، نستمر لطلب البيانات من السيرفر
                }
            }
            
            // طلب البيانات من السيرفر
            const response = await settingsApi.getSeoSettings();
            setSettings(response);
            
            // تخزين البيانات في sessionStorage مع وقت التخزين
            const cacheData = { ...response, _cacheTime: Date.now() };
            sessionStorage.setItem('seo_settings', JSON.stringify(cacheData));
        } catch (error) {
            // Handle settings loading error
            
            // في حالة الخطأ، حاول استخدام البيانات المخزنة إن وجدت
            const cachedSettings = sessionStorage.getItem('seo_settings');
            if (cachedSettings) {
                try {
                    const parsedSettings = JSON.parse(cachedSettings);
                    delete parsedSettings._cacheTime;
                    setSettings(parsedSettings);
                    // Fallback to cached settings due to connection error
                } catch (e) {
                    // Cannot use cached settings
                }
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <SettingsContext.Provider value={{ settings, loading, loadSettings }}>
            {children}
        </SettingsContext.Provider>
    );
};
